import { useEffect, useState } from "react";
import swal from "sweetalert";
import { post_training, trainingName_get } from "../../Services/service";
import { getData, postData } from "../../Services/Api";
import MaterialTable from "@material-table/core";
import Swal from "sweetalert2";
import { Button, Modal, Form } from "react-bootstrap";
import axios from "axios";
import { Trash2 } from "lucide-react";
import { BASE_URL } from "../helper";

const Employee = () => {
  const [data, setData] = useState({ trainingName: "", description: "" });
  const [errors, setErrors] = useState({});
  const [errorShow, setErrorShow] = useState(false);
  const [ticketDetails, setTicketDetails] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editData, setEditData] = useState({
    id: "",
    trainingName: "",
    description: "",
  });

  const inputChangeHandler = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const handleKeytraining = (event) => {
    const { key } = event;

    // Block input that consists of spaces only
    if (/^\s+$/.test(key) && event.target.value.trim() === "") {
      event.preventDefault();
      return;
    }

    // Block characters that are not allowed in a holiday type
    if (!/^[a-zA-Z\s]+$/.test(key)) {
      event.preventDefault();
    }
  };
  const handleKeytrainingdesc = (event) => {
    const { key } = event;

    // Block characters that are not allowed in a phone number
    if (/^\s+$/.test(key) && event.target.value.trim() === "") {
      event.preventDefault();
      return;
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    console.log(JSON.stringify(data));

    try {
      const resp = await postData(data, post_training);
      const res = await resp.json();

      if (res.Status === 200) {
        console.log("Event Name Added");
        swal("Success", "Event Added Successfully", "success");
        FetchData();
        setData({
          trainingName: "",
          description: "",
        });
        setErrors({
          trainingName: "",
          description: "",
        });
        setErrorShow(false);
      } else {
        setErrors({
          trainingName: res?.trainingName || "",
          description: res?.description || "",
        });
        setErrorShow(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success m-3",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });

  const handleDelete = (id) => {
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
      })
      .then((result) => {
        if (result.isConfirmed) {
          swalWithBootstrapButtons.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
            icon: "success",
            timer: 1000, // Timer set to 1000 milliseconds (1 second)
            showConfirmButton: false,
          });
          debugger;
          console.log(id);
          fetch(`${BASE_URL}/trainingName/delete/${id}`, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          })
            .then((result) => result.json())
            .then((response) => {
              console.log(response);
              if (response?.Status === 200) {
                FetchData();
              }
            });
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          // Handle cancel operation if needed
        }
      });
  };

  const FetchData = () => {
    getData(trainingName_get)
      .then((response) => response.json())
      .then((res) => {
        if (res.Status == 200) {
          console.log("ttttttt", res?.Data);
          setTicketDetails(res?.Data);
        }
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    FetchData();
  }, []);

  const handleEdit = (rowData) => {
    setSelectedRow(rowData);
    setEditData(rowData);
    setShowModal(true);
  };

  const handleUpdate = async () => {
  const url = `${BASE_URL}/trainingName/update/${selectedRow.id}`;
    try {
      const response = await axios.put(url, editData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      console.log("ressssssssss", response);
      const updatedData = response.data;
      setData(updatedData);
      console.log("qqqqqqqqq", updatedData);
      setShowModal(false);
      swal("Success", "Data Updated Successfully", "success");
      FetchData();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <>
      <div className="container">
        <div className="d-flex">
          <h3>Add Training Details</h3>
        </div>
        <hr />
        <form onSubmit={submitHandler}>
          <div className="row">
            <div className="col-sm-4 ">
              <label htmlFor="formGroupExampleInput" id="label">
                Training Name: <span style={{ color: "red" }}> * </span>
              </label>

              <input
                value={data.trainingName}
                type="text"
                className="form-control"
                id="formGroupExampleInput"
                name="trainingName"
                onChange={inputChangeHandler}
                placeholder="Please Enter Training Name"
                onKeyPress={handleKeytraining}
              />
              {errorShow && (
                <span style={{ color: "red" }}>{errors.trainingName}</span>
              )}
            </div>

            <div className="col-sm-4">
              <label htmlFor="formGroupExampleInput" id="label">
                Description: <span style={{ color: "red" }}> * </span>
              </label>

              <input
                value={data.description}
                type="text"
                className="form-control"
                id="formGroupExampleInput"
                name="description"
                onChange={inputChangeHandler}
                placeholder="Write Something Here"
                onKeyPress={handleKeytrainingdesc}
              />
              {errorShow && (
                <span style={{ color: "red" }}>{errors.description}</span>
              )}
            </div>
          </div>
          <br></br>
          <button type="submit" className="btn btn-primary ">
            Save
          </button>
          <br></br>
          <br></br>

          <MaterialTable
            style={{ width: "76vw",margin:"0 auto" }}
            title="Training Record"
            data={ticketDetails}
            columns={[
              {
                title: "Training Name",
                field: "trainingName",
              },

              {
                title: "Description",
                field: "description",
              },
              {
                title: "Actions",
                field: "actions",
                render: (rowData) => (
                  <span className="push-button">
                    <Trash2
                      color="#c07c7c"
                      onClick={() => handleDelete(rowData.id)}
                    />
                  </span>
                ),
              },
              {
                title: "Actions",
                field: "actions",
                render: (rowData) => (
                  <i
                    className="fa fa-pencil-square-o"
                    aria-hidden="true"
                    style={{ fontSize: "25px" }}
                    onClick={() => handleEdit(rowData)}
                    type="submit"
                  ></i>
                ),
              },
            ]}
          />
        </form>
      </div>

      <div className="container">
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Form>
            <Modal.Header closeButton>
              <Modal.Title>Edit Training Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {/* Render input fields for editing data */}
              <Form.Group controlId="id">
                <Form.Label>ID</Form.Label>
                <Form.Control
                  type="text"
                  name="id"
                  value={editData.id}
                  onChange={handleInputChange}
                  disabled
                />
              </Form.Group>
              <Form.Group controlId="trainingName">
                <Form.Label>Training Name</Form.Label>
                <Form.Control
                  type="text"
                  name="trainingName"
                  value={editData.trainingName}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="description">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  type="text"
                  name="description"
                  value={editData.description}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Close
              </Button>
              <Button variant="primary" onClick={handleUpdate}>
                Save Changes
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    </>
  );
};

export default Employee;
